import { useTheme } from '@mui/styles';
import { useMemo } from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export interface ClientThemeData {
    names: ApplicationMuiTheme['app']['clientTheme']['names'];
    support: ApplicationMuiTheme['app']['clientTheme']['support'];
}

const emptyClientInfo: ClientThemeData = {
    names: {
        clientName: '',
        applicationName: '',
        tokenName: ''
    },
    support: {
        contactInfo: {
            address: {
                streetLine1: '',
                steetLine2: '',
                city: '',
                state: '',
                zipCode: ''
            },
            companyWebsite: {
                url: '',
                hyperlinkText: ''
            },
            applicationWebsite: {
                url: '',
                hyperlinkText: ''
            },
            cybersecurityWebsite: {
                url: '',
                hyperlinkText: ''
            },
            privacyWebsite: {
                url: '',
                hyperlinkText: ''
            },
            email: '',
            phoneDirect: '',
            phoneTollFree: '',
            contactTime: ''
        },
        files: [],
        copyright: { startYear: '' },
        page: {
            contact: { blurb: '' },
            maintenance: {
                blurb1: '',
                blurb2: '',
                blurb3: ''
            },
            disclosures: {
                blurb1: '',
                blurb2: '',
                blurb3: ''
            },
            corporate: {
                blurb1: '',
                blurb2: '',
                blurb3: ''
            }
        }
    }
};

export const useClientThemeData = (): ClientThemeData => {
    const muiTheme = useTheme<ApplicationMuiTheme>();

    const clientInfo = useMemo(() => {
        if (!muiTheme.app) return emptyClientInfo;

        const info: ClientThemeData = {
            names: muiTheme.app.clientTheme.names,
            support: muiTheme.app.clientTheme.support
        };

        return info;
    }, [muiTheme]);

    return clientInfo;
};